import { deleteLinkByHref, formatTextLinkTags } from "@/helpers/formatText";
import { HoroscopeDetailContainer } from "./style";
import SocialNetworking from "@/shared/SocialNetworking";
import { useRouter } from "next/router";
import { TextContainer } from "./style";
import { Fragment } from "react";

export const HoroscopeDetail = ({ sign, isZodiacChinese, isTomorrow, isToday, isHowIs, isYearPredictionsZodiac }) => {
  const router = useRouter();
  const tomorrowClass = isTomorrow ? "checked" : "";
  const todayClass = isToday ? "checked" : "";
  const howIsClass = isHowIs ? "checked" : "";
  const YearPredictionsZodiacClass = isYearPredictionsZodiac ? "checked" : "";
  function withoutTilde(sign) {
    if (!sign) {
      return "";
    }
  
    sign = sign
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    
    return sign;
  }
  const processText = (text) => {
    let processedText = text;
    processedText = deleteLinkByHref(processedText, "undefined");
    processedText = deleteLinkByHref(processedText, "unsafe:[object Object]");
    processedText = formatTextLinkTags(processedText);
    return processedText;
  };

  const processTextBlack = (texto) => {
    if (!texto) {
      return null;
    }
  
    const regex = /\b(Aries|Tauro|Géminis|Cáncer|Leo|Virgo|Libra|Escorpio|Sagitario|Capricornio|Acuario|Piscis)\b/g;
    const textoConNegritas = texto.replace(regex, "<span class='black-sign'>$1</span>");
    
    return (
      <div dangerouslySetInnerHTML={{ __html: textoConNegritas }}/>
    );
  };
  
  
  let getUrl = sign?.map((el) => {
    const signName = el?.sign ? el.sign.replace(/^\w/, (letra) => letra.toUpperCase()) : '';
    return {
      url: router.asPath,
      title: signName,
    };
  });

  const yearActive =  router.query.match[2] || 'predicciones-2025';
 
  return (   
    <HoroscopeDetailContainer>
      { sign?.map((element, index) => {
        const {
          since,
          until,
          sign,
          prediction,
          characteristics,
          description,
          years,
          data,
        } = element;

        if (!sign && !since && !until && data.every(dataEl => !dataEl.descripcion)) {
          return null;
        }

        let year;
        if (years) {
          const firstYear = years?.map((year) => year.split(",")[0]);
          year = firstYear.join(", ");
        }

        

        let url = isZodiacChinese
          ? [
              `/horoscopo-chino/caracteristicas-${withoutTilde(sign)}`,
              `/horoscopo-chino/prediccion-${withoutTilde(sign)}`,
            ]
          : [`/horoscopo/signos-zodiaco-${withoutTilde(sign)}`];

          let urlToday = isZodiacChinese
          ? `/horoscopo-chino/caracteristicas-${withoutTilde(sign)}`
          : `/horoscopo/signos-zodiaco-${withoutTilde(sign)}/horoscopo-diario`;

        let urlTomorrow = isZodiacChinese
          ? `/horoscopo-chino/caracteristicas-${withoutTilde(sign)}`
          : `/horoscopo/signos-zodiaco-${withoutTilde(sign)}/horoscopo-manana`;

        let urlYearPredictions = isZodiacChinese
          ? `/horoscopo-chino/prediccion-${withoutTilde(sign)}`
          : `/horoscopo/signos-zodiaco-${withoutTilde(sign)}/predicciones-2025`;  

        return (
          <div
            className="horoscope-detail-sign-container"
            key={`sign-${index}`}
          >
            <div
              className="horoscope-detail-sign"
              style={{ position: "relative" }}
            >
              <figure className="horoscope-detail-image">
                <img
                  alt={`sign`}
                  src={`/img/westernastrology/${withoutTilde(sign)}.svg`}
                  width="105px"
                  height="105px"
                  loading="lazy"
                />
              </figure>

              <div className="">
                <div className="horoscope-detail-name">{sign}</div>

                <div className="horoscope-detail-date">
                  {isZodiacChinese ? (
                    <div className="horoscope-detail-years">
                      <span>{year}</span>
                    </div>
                  ) : (
                    <>
                      <div className="horoscope-detail-since">
                        {since ? since.slice(-2) + "/" + since.slice(0, 2) : ""}
                      </div>
                      <div className="horoscope-detail-dash">-</div>
                      <div className="horoscope-detail-until">
                        {until ? until.slice(-2) + "/" + until.slice(0, 2) : ""}
                      </div>
                    </>
                  )}
                </div>

                {!isZodiacChinese ? (
                  <ul className="astrology-day">
                     <li>
                    <h3>
                     <a
                       href={url}
                       target="_self"
                       aria-label={withoutTilde(sign)}
                       className={`astrology-today ${howIsClass}`}
                     >
                       Cómo son
                     </a>
                     </h3>
                   </li>                
                    <li>
                      <h3>
                      <a
                        href={urlToday}
                        target="_self"
                        aria-label={withoutTilde(sign)}
                        className={`astrology-today ${todayClass}`}
                      >
                        Hoy
                      </a>
                      </h3>
                    </li>
                    <li>
                      <h3>
                      <a
                        href={urlTomorrow}
                        target="_self"
                        aria-label={withoutTilde(sign)}
                        className={`astrology-today ${tomorrowClass}`}
                      >
                        Mañana
                      </a>
                      </h3>
                    </li>
                    <li>
                      <h3>
                      <a
                        href={urlYearPredictions}
                        target="_self"
                        aria-label={withoutTilde(sign)}
                        className={`astrology-today ${YearPredictionsZodiacClass}`}
                      >
                        Predicciones 2025
                      </a>
                      </h3>
                    </li>
                  </ul>
                ) : null}
              </div>
            </div>

            <div className="horoscope-detail-content" id={sign}>
              {isZodiacChinese ? (
                <>
                  <div className="horoscope-detail-content-description written-by">
                    {processText(description)}
                  </div>
                  {(router.asPath?.includes("prediccion") ||
                    !isZodiacChinese) &&
                    prediction?.map((item, index) => (
                      <div
                        className="horoscope-detail-content-text"
                        key={`pred-${index}`}
                      >
                        <div className="horoscope-detail-content-title chinese-title">
                          {processText(item.title)}
                        </div>
                        {isZodiacChinese ? (
                          <div className="chinese"
                            dangerouslySetInnerHTML={{ __html: item.content }}
                          />
                        ) : (
                          <div className="horoscope-detail-content-description">
                            {processText(item.content)}
                          </div>
                        )}
                      </div>
                    ))}
                  {router.asPath?.includes("caracteristicas") &&
                    isZodiacChinese &&
                    characteristics?.map((item, index) => (
                      <div
                        className="horoscope-detail-content-text"
                        key={`pred-${index}`}
                      >
                        <h1 className="horoscope-detail-content-title chinese-title">
                          {processText(item.title)}
                        </h1>
                        {isZodiacChinese ? (
                          <div className="chinese"
                            dangerouslySetInnerHTML={{ __html: item.content }}
                          />
                        ) : (
                          <div className="horoscope-detail-content-description">
                            {processText(item.content)}
                          </div>
                        )}
                      </div>
                    ))}
                </>
              ) : (
                data &&
                data.map((item, index) => (                                    
                  <div
                    className="horoscope-detail-content-text"
                    key={`detail-${index}`}
                  >
                    {isHowIs &&
                    <div className="horoscope-detail-content-characteristic">
                    <h2>Características de {sign}</h2>
                    {/* <ul>
                      <li>Elemento: {item.caracteristicas.elemento}</li>
                      <li>Regente: {item.caracteristicas.regente}</li>
                      {item.caracteristicas.corregente &&
                      <li>Corregente: {item.caracteristicas.corregente}</li>
                      }
                      <li>Metal: {item.caracteristicas.metal}</li>
                      <li>Piedras: {item.caracteristicas.piedras.join(", ")}</li>
                      {item.caracteristicas.complementario &&
                      <li>Complementario: {item.caracteristicas.complementario}</li>
                      }
                      {item.caracteristicas.dia &&
                      <li>Día: {item.caracteristicas.dia}</li>
                      }
                      <li>Cuerpo: {item.caracteristicas.cuerpo.join(", ")}</li>
                    </ul> */}
                    </div>
                    }
                    <div className="horoscope-detail-content-title">
                      {processText(item.nombre)}
                    </div>
                    {!isYearPredictionsZodiac &&
                    <div className="horoscope-detail-content-description">
                     <div dangerouslySetInnerHTML={{ __html: item.descripcion }}/>
                    </div>
                    
                    }
                    { 
                     isYearPredictionsZodiac && item?.caracteristicas?.map( (element, index) => (
                      <Fragment key = {index} >
                        <div className="horoscope-detail-content-characteristic">
                          <h2>{element.title}</h2>
                        </div>
                        <div className="horoscope-detail-content-characteristic">  
                          <div dangerouslySetInnerHTML={{ __html: element.content }}/>
                        </div>
                      </ Fragment>
                      ))
                    }

                    {isYearPredictionsZodiac && 
                      <div className="horoscope-detail-content-characteristic">
                          <i>Asesoró la astróloga y tarotista Lourdes Ferro.</i>
                      </div>
                    }
                       
                    {isHowIs &&
                    <div className="horoscope-detail-content-characteristic">
                      <h2>Fortalezas de {sign}</h2>
                      <div dangerouslySetInnerHTML={{ __html: item.fortalezas }}/>
                      <h2>Debilidades de {sign}</h2>
                      <div dangerouslySetInnerHTML={{ __html: item.debilidades }}/>
                      <h2>Compatibilidades de {sign}</h2>                 
                        {processTextBlack(item.compatibilidad.descripcion)} 
                        <div>Asesoró Beatriz Leveratto, astróloga, tarotista y directora de la escuela Consideral de astrología y tarot.</div>                                   
                    </div>
                    }  
                  </div>
                ))
              )}
              {router.asPath?.includes("prediccion") && isZodiacChinese && (
                <a
                  className="button-redirect"
                  href={getUrl?.[0]?.url?.replace(
                    "prediccion",
                    "caracteristicas"
                  )}
                >
                  Ver características
                </a>
              )}
              {router.asPath?.includes("caracteristicas") &&
                isZodiacChinese && (
                  <a
                    className="button-redirect"
                    href={getUrl?.[0]?.url?.replace(
                      "caracteristicas",
                      "prediccion"
                    )}
                  >
                    Predicciones 2025
                  </a>
                )}
            </div>
            <div className="horoscope-detail-share">
              <SocialNetworking
                url={getUrl[0].url}
                title={getUrl[0].title}
                socialNetworkingSelect={[
                  "facebook",
                  "twitter",
                  "whatsapp",
                  "share",
                ]}
              />
            </div>
          </div>
        );
      })}
    </HoroscopeDetailContainer>
  );
};
